import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// The one stylesheet entry (shared with Storybook): Inter, Figma tokens, global base.
import '@deepdive-ui/styles.css';

import { App } from './app/App';
import { installChunkReloadGuard } from './services/chunkReload';

installChunkReloadGuard();

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
